/**
 * Shared CSV import helpers for the setup flow.
 * Used by setupPage.js and performanceOnboardingBanner.js.
 */

export const formatCsvImportError = (err) => {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.detail) {
    return Array.isArray(data.detail) ? data.detail.join(" ") : String(data.detail);
  }

  if (data && typeof data === "object") {
    const msg = Object.entries(data)
      .map(([key, value]) => {
        if (Array.isArray(value)) return `${key}: ${value.join(", ")}`;
        if (value && typeof value === "object") return `${key}: ${JSON.stringify(value)}`;
        return `${key}: ${String(value)}`;
      })
      .join(" | ");
    if (msg) return msg;
  }

  return err?.message || "Failed to import CSV.";
};
